export default "__VITE_ASSET__XkCAXxkq__"